exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ng-invalid {\n    border-color: red;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/user/profile/profile.component.css
// module id = ../../../../../src/app/user/profile/profile.component.css
// module chunks = main